import { render } from "./Payment.vue?vue&type=template&id=cd703104"
const script = {}
script.render = render

export default script